import React from "react";
import { useParams } from "react-router-dom";
import DynamicEditForm from "../../components/AdvanceDynamicEdit/DynamicEditForm";
import { getStoredData } from "../../json/fecthData";

const DynamicEditPage = () => {
  const { key, id } = useParams(); // 🧠 Also grabbing ID from URL
  const config = getStoredData()?.[3]?.[key]; // Access correct section of config

  if (!config) return <p>❌ Invalid edit config for "{key}"</p>;

  const {
    Title = "Item",
    Fields = [],
    RedirectPath = "/",
    ApiPath = key,
  } = config;

  return (
    <div>
      <h2>Edit {Title}</h2>
      <DynamicEditForm
        fields={Fields}
        apiUrl={`https://hammontrackingbackend-3.onrender.com/${ApiPath}`} // ✅ Actual GET/PUT URL
        successRedirect={RedirectPath}
      />
    </div>
  );
};

export default DynamicEditPage;
